<template>
<div>
<cAgentDeposit/>
    <!-- <CCard>


    <footer class="card-footer d-flex justify-content-end">
        <div class="row d-flex justify-content-end">

            <div class="col" style="white-space: nowrap;">

                <button type="button"  @click="navToAgentDepositPay"  class="btn btn action-c-btn btn-success" > {{$t('agentDeposit.continue')}}</button>
            </div>
        </div>
    </footer>
    </CCard> -->

</div>

  
</template>

<script>

import cAgentDeposit from './../../components/postpaid/cAgentDeposit'
import {
  PATHNAME,
  COMPONENT_NAME,
  SECTOR_TYPE,
  PRICING_VALUE,
  DEFAULT_DROPDOWN_STATUS,
  POSTPAID_STATEMENT_STATUS,
  POSTPAID_TYPE
} from "./../../util/constants";
import { addClassToBody,removeClassBody } from "../../util/util";
import BaseConfiguration from "../../config/base";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { navigate } from '../../router';
export default {


name:COMPONENT_NAME.AGENT_DEPOSIT,
components:{
  cAgentDeposit
},
 methods: {
   
   navToAgentDepositPay() {
       try {
         if(BaseConfiguration.isDebug) console.log("navToAgentDepositPay");
        navigate(PATHNAME.AGENT_DEPOSIT_PAY);
   
       } catch (err) {
               let body = Logger.buildRequest(
                 COMPONENT_NAME.AGENT_DEPOSIT,
                 "error in navToAgentDepositPay",
                 err.toString(),
                 "navToAgentDepositPay",
                 LOG_TYPE.ERROR
               );
               Logger.getResponse(body);
             }
        
       }, 
 },
 beforeCreate() {    
   addClassToBody(COMPONENT_NAME.AGENT_DEPOSIT);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
}
</script>

<style>

</style>